import axios, { CancelToken } from 'axios';
import store from '@/store';
import Vue from 'vue';
import User from '@/services/User/User';

const EXPIRED_MESSAGE = 'EXPIRED_MESSAGE';

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    Authorization: 'Bearer {token}',
  },
});

api.CancelToken = axios.CancelToken;
api.isCancel = axios.isCancel;

// Set the AUTH token for any request
api.interceptors.request.use((config) => {
  const token = store.getters.authToken;
  config.headers.Authorization = token ? `Bearer ${token}` : '';

  return config;
});

// Log out the user if they find unauthorized
api.interceptors.response.use(
  response => Promise.resolve(response),
  (error) => {
    // We are checking here to see if they are expired, and to log them out if so
    if (error.message) {
      if (error.message === EXPIRED_MESSAGE) {
        store.dispatch('logout', { expired: true });
        return;
      }
    }

    if (error.response) {
      if (error.response.status === 401) {
        store.dispatch('logout');
        return;
      }
    }

    return Promise.reject(error);
  },
);

export default api;
